<template>
  <el-card>
    <div slot="header">
      Alapadatok
    </div>
    <el-form
      ref="basicDataForm"
      :model="basicData"
      :rules="rules"
      label-position="top"
      autocomplete="off"
    >
      <el-form-item
        prop="is_active"
      >
        <el-switch
          v-model="basicData.is_active"
          active-text="Aktív"
        />
      </el-form-item>
      <el-form-item
        prop="categories"
        label="Csoportok"
      >
        <el-cascader
          v-model="basicData.categories"
          :options="userCategories"
          :props="{ checkStrictly: true, label: 'name', value: 'id', multiple: true, emitPath: false }"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item
        prop="roles"
        label="Jogkörök"
      >
        <el-select
          v-model="basicData.roles"
          filterable
          multiple
          placeholder="Válassz jogköröket"
          style="width: 100%;"
        >
          <el-option
            v-for="role in roles"
            :label="role.name"
            :value="role.id"
            :key="role.id"
          />
        </el-select>
      </el-form-item>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="last_name"
            label="Vezetéknév"
          >
            <el-input
              v-model="basicData.last_name"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="first_name"
            label="Keresztnév"
          >
            <el-input
              v-model="basicData.first_name"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="username"
            label="Felhasználónév"
            :error="errors.username ? errors.username[0] : null"
          >
            <el-input
              v-model="basicData.username"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="mobile"
            label="Mobil"
          >
            <el-input
              v-model="basicData.mobile"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="email"
            label="E-mail cím"
          >
            <el-input
              v-model="basicData.email"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="password"
            label="Jelszó"
          >
            <el-input
              type="password"
              autocomplete="new-password"
              v-model="basicData.password"
              @keyup.enter.native="add"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="invoice_books"
            label="Kezelt számla- és nyugtatömbök"
          >
            <el-select
              v-model="basicData.invoice_books"
              collapse-tags
              filterable
              multiple
              placeholder="Válassz számlatömböket"
              style="width: 100%;"
            >
              <el-option
                v-for="invoiceBook in invoiceBooks"
                :label="invoiceBook.name"
                :value="invoiceBook.id"
                :key="invoiceBook.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="storage_access"
            label="Raktárak"
          >
            <el-select
              v-model="basicData.storage_access"
              collapse-tags
              filterable
              multiple
              placeholder="Válassz raktárakat"
              style="width: 100%;"
            >
              <el-option
                v-for="storage in storages"
                :label="storage.name"
                :value="storage.id"
                :key="storage.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="default_storage_id"
            label="Központi raktár"
          >
            <el-select
              v-model="basicData.default_storage_id"
              collapse-tags
              filterable
              clearable
              placeholder="Válassz raktárat"
              style="width: 100%;"
            >
              <el-option
                v-for="storage in centralStorages"
                :label="storage.name"
                :value="storage.id"
                :key="storage.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-checkbox
            v-model="basicData.is_representative"
          >
            Képviselő
          </el-checkbox>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</template>
<script>
  export default {
    props: ['user', 'errorData', 'dialogType'],
    data() {
      return {
        storages: [],
        errors: {
          username: null,
        },
        basicData: {
          is_active: true,
          is_representative: true,
        },
        rules: {
          roles: [
            { required: true, message: 'Jogkör megadása kötelező', trigger: 'change' }
          ],
          email: [
            {
              required: true,
              message: 'E-mail cím megadása kötelező',
              trigger: 'blur'
            },
            {
              type: 'email',
              message: 'Hibás formátum',
              trigger: 'blur'
            }
          ],
          last_name: [
            {
              required: true,
              message: 'Vezetéknév megadása kötelező',
              trigger: 'blur'
            }
          ],
          first_name: [
            {
              required: true,
              message: 'Keresztnév megadása kötelező',
              trigger: 'blur'
            }
          ],
          username: [
            {
              required: true,
              message: 'Felhasználónév megadása kötelező',
              trigger: 'blur'
            }
          ],
          password: [
            {
              required: this.type === 'add',
              message: 'Jelszó megadása kötelező',
              trigger: 'blur'
            }
          ],
        }
      };
    },
    computed: {
      userCategories() {
        return this.$store.getters['userCategory/userCategories'];
      },
      roles() {
        return this.$store.getters['role/roles'];
      },
      invoiceBooks() {
        return this.$store.getters['invoiceBook/invoiceBooks'];
      },
      centralStorages() {
        return this.storages.filter(s => s.type === 'own');
      }
    },
    watch: {
      user(newVal) {
        this.basicData = JSON.parse(JSON.stringify(newVal));
      },
      errorData(newVal) {
        this.errors = newVal;
      }
    },
    methods: {
      add() {
        this.$emit('add');
      }
    },
    async mounted() {
      this.storages = await axios.get('api/storage-list')
    },
  };
</script>
